<template>
  <div v-if="list.baseStation&&!SsPsShow">
    <table >
      <tr>
        <th>{{$t('lang.particulars.MNC')}}</th>
        <td
          v-if="list.baseStation.clMnc!='-'&&list.baseStation.clMnc!=''"
        >{{list.baseStation.clMnc}}</td>
        <td v-else-if="list.baseStation.clMnc=='-'">{{list.baseStation.clMnc}}</td>
        <td v-else>-</td>
        <th>{{$t('lang.particulars.MCC')}}</th>
        <td
          v-if="list.baseStation.clMcc!='-'&&list.baseStation.clMnc!=''"
        >{{list.baseStation.clMcc}}</td>
        <td v-else-if="list.baseStation.clMcc=='-'">{{list.baseStation.clMcc}}</td>
        <td v-else>-</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.LocationListener')}}</th>
        <td
          v-if="list.baseStation.clCid!='-'&&list.baseStation.clCid!=''"
        >{{list.baseStation.clCid}}</td>
        <td v-else-if="list.baseStation.clCid=='-'">{{list.baseStation.clCid}}</td>
        <td v-else>-</td>
        <th>{{$t('lang.particulars.networkRemoveOk')}}</th>
        <td v-if="list.baseStation&&list.baseStation.clRat==false">GSM/WCDMA/TD-SCDMA/LTE</td>
        <td v-else-if="list.baseStation&&list.baseStation.clRat==true">CDMA</td>
        <td v-else></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ['list', 'SsPsShow'],
  data() {
    return {

    }
  }
}
</script>
<style scoped src='./particulars.css'></style>